import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PRODUCT } from '../../../constants/queryKeys';
import productApiV2 from '../../../lib/api/product/ProductApiV2';
import { GetProductListRequest } from '../../../lib/api/product/type';
import { QueryOptions } from '../../../types/query/useQuery';
import { ProductsResponseBodyDto } from '../../../types/api/products';

type UseProductListQueryArgsType<SelectResultType> = {
  payload: GetProductListRequest;
  options?: QueryOptions<ProductsResponseBodyDto, unknown, SelectResultType>;
};
export const useProductList = <SelectResultType>({
  payload,
  options,
}: UseProductListQueryArgsType<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<ProductsResponseBodyDto, unknown, SelectResultType>(
    [...PRODUCT.LIST, payload],
    (): Promise<ProductsResponseBodyDto> => productApiV2.getProductList(payload),
    {
      ...options,
    },
  );
};
export default useProductList;
